import { postConfig } from './helpers';

let iti;
let isEmailValid = false;
let isPhoneValid = false;

const production = window.wmd.production;

const fetchThankYouPage = async () => {
  const response = await fetch('https://wendymorrisondesign.com/pages/thank-you-custom');
  return response.text();
};

const extractMainContent = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  return doc.querySelector('#MainContent');
};

const handleSubmit = async (event) => {
  event.preventDefault();

  if (!isEmailValid || !isPhoneValid) {
    return;
  }

  const form = document.getElementById('wmdContactForm');
  let scrollElement;

  // check custom size elements first
  const width = form.querySelector('#ContactForm-width');
  const length = form.querySelector('#ContactForm-length');

  const width_ft = form.querySelector('#ContactForm-width-ft');
  const width_in = form.querySelector('#ContactForm-width-in');
  const length_ft = form.querySelector('#ContactForm-length-ft');
  const length_in = form.querySelector('#ContactForm-length-in');

  const isMetricWidthInvalid = !!width && width.required && (!width.value || parseFloat(width.value) === 0.0);
  const isImperialWidthInvalid =
    !!width_ft && width_ft.required &&
    !!width_in && width_in.required &&
    (!width_ft.value || parseFloat(width_ft.value) === 0.0) &&
    (!width_in.value || parseFloat(width_in.value) === 0.0);
  const isMetricLengthInvalid = !!length && length.required && (!length.value || parseFloat(length.value) === 0.0);
  const isImperialLengthInvalid =
    !!length_ft && length_ft.required &&
    !!length_in && length_in.required &&
    (!length_ft.value || parseFloat(length_ft.value) === 0.0) &&
    (!length_in.value || parseFloat(length_in.value) === 0.0);

  if (isMetricWidthInvalid || isImperialWidthInvalid) {
    scrollElement = form.querySelector('#custom-size-scroll-target');
    alert('Custom size must have a width');
    scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    return false;
  }

  if (isMetricLengthInvalid || isImperialLengthInvalid) {
    scrollElement = form.querySelector('#custom-size-scroll-target');
    alert('Custom size must have a length');
    scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    return false;
  }

  const requiredFields = form.querySelectorAll('input[required], select[required], textarea[required]');
  let requiredEmpty = 0;
  let radioChecked = new Set();
  const emptyFields = [];
  requiredFields.forEach(field => {
    if (field.value === '' || !field.value) {
      emptyFields.push(field.name);
      requiredEmpty++;
    }
    if (field.type === 'radio') {
      if (!radioChecked.has(field.name)) {
        radioChecked.add(field.name);
        const group = form.querySelectorAll(`input[type='radio'][name='${field.name}']`);
        const oneRadioChecked = Array.from(group).some(radio => radio.checked);
        if (!oneRadioChecked) {
          emptyFields.push(field.name);
          requiredEmpty++;
        }
      }
    }
  });
  if (requiredEmpty) {
    const firstRequiredElementName = emptyFields[0];
    scrollElement = document.querySelector(`input[name='${firstRequiredElementName}']`);
    alert('Please complete all required fields');
    scrollElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    return false;
  }

  const json = serializeFormToJSON(form);
  window.grecaptcha.ready(async function() {
    const token = await window.grecaptcha.execute('6LdRSukqAAAAAIltDZRCSDNcs1gWrQ7wmzh8i_sQ', { action: 'submit' });
    const postData = postConfig({
      greToken: token,
      form: json
    });
    const response = await fetch('/apps/wmd/api/send', postData);
    const data = await response.json();

    if (data.status === 200) {
      if (window.wmd?.redirect) {
        window.location.href = window.wmd?.redirectUrl;
      }
      else {
        if (window.wmd?.customSize) {
          const html = await fetchThankYouPage();
          const text = extractMainContent(html);
          document.querySelector('.custom-size-modal .contact.page-width h2.title').remove();
          document.querySelector('.custom-size-modal .contact.page-width div.rte').remove();
          document.getElementById('wmdContactForm').remove();
          document.getElementById('responseText').appendChild(text);
        }
        else {
          document.getElementById('successMessage').innerText = data.message;
          document.querySelector('.successful-post').style.display = 'block';
          document.querySelector('.unsuccessful-post').style.display = 'none';
          document.getElementById('wmdContactForm').reset();
          const scrollElement = document.getElementById(`shopify-section-${window.wmd?.scrollTarget}`);
          scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          const stickyHeader = document.querySelector('.shopify-section-header-sticky');
          if (stickyHeader) {
            const onScrollEnd = () => {
              stickyHeader.classList.add('shopify-section-header-hidden');
              window.removeEventListener('scrollend', onScrollEnd);
            };
            window.addEventListener('scrollend', onScrollEnd);
          }
        }
      }
    }
    else {
      document.getElementById('failureMessage').innerText = data.message;
      document.querySelector('.unsuccessful-post').style.display = 'block';
      document.querySelector('.successful-post').style.display = 'none';
      const scrollElement = document.getElementById(`shopify-section-${window.wmd?.scrollTarget}`);
      scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const stickyHeader = document.querySelector('.shopify-section-header-sticky');
      if (stickyHeader) {
        const onScrollEnd = () => {
          stickyHeader.classList.add('shopify-section-header-hidden');
          window.removeEventListener('scrollend', onScrollEnd);
        };
        window.addEventListener('scrollend', onScrollEnd);
      }
    }
  });
};

function serializeFormToJSON(form) {
  const formData = new FormData(form);
  const jsonObject = {};

  formData.forEach((value, key) => {
    jsonObject[key] = value;
  });

  return JSON.stringify(jsonObject);
}

const checkEnableSubmitButton = () => {
  document.getElementById('wmdSubmit').disabled = !(isEmailValid && isPhoneValid);
};

const formatNumber = (event) => {
  checkEnableSubmitButton();
  const number = iti.getNumber();
  isPhoneValid = iti.isValidNumber();
  if (isPhoneValid) {
    isPhoneValid = true;
    document.getElementById('ContactForm-phone').value = number;
    document.getElementById('phoneValid').innerText = '';
    checkEnableSubmitButton();
  }
  else {
    isPhoneValid = false;
    document.getElementById('phoneValid').innerText = 'Phone number not valid';
    checkEnableSubmitButton();
  }
};

const manageState = (event) => {
  if (event.target.value === 'United States') {
    document.getElementById('us-state').style.display = 'block';
    document.getElementById('AddressState').disabled = false;
    document.getElementById('AddressState').required = true;
  }
  else {
    document.getElementById('us-state').style.display = 'none';
    document.getElementById('AddressState').disabled = true;
    document.getElementById('AddressState').required = false;
  }
};

const getPrice = (area) => {
  return window.wmd.pricePerCmSq.find(
    p => p.production === production && area > p.min_area && (p.max_area === null || area <= p.max_area))?.price;
};

const calculatePrice = () => {
  const rugType = window.wmd.rugType;
  let width = null, length = null, diameter = null;
  const units = document.querySelector('input[name="units"]:checked')?.value || null;
  if (rugType === 'rectangular') {
    switch (units) {
      case 'Metric':
        width = parseFloat(document.getElementById('ContactForm-width').value);
        length = parseFloat(document.getElementById('ContactForm-length').value);
        break;
      case 'Imperial':
        if (document.getElementById('ContactForm-width-ft').value === '') {
          document.getElementById('ContactForm-width-ft').value = 0;
        }
        if (document.getElementById('ContactForm-width-in').value === '') {
          document.getElementById('ContactForm-width-in').value = 0;
        }
        if (document.getElementById('ContactForm-length-ft').value === '') {
          document.getElementById('ContactForm-length-ft').value = 0;
        }
        if (document.getElementById('ContactForm-length-in').value === '') {
          document.getElementById('ContactForm-length-in').value = 0;
        }
        const widthFt = parseInt(document.getElementById('ContactForm-width-ft').value);
        const widthIn = parseFloat(document.getElementById('ContactForm-width-in').value);
        const lengthFt = parseInt(document.getElementById('ContactForm-length-ft').value);
        const lengthIn = parseFloat(document.getElementById('ContactForm-length-in').value);
        if (widthIn > 11 || lengthIn > 11) {
          return false;
        }
        // convert to cm
        width = ((widthFt * 12) + widthIn) * 2.54;
        length = ((lengthFt * 12) + lengthIn) * 2.54;
        break;
    }
  }
  if (rugType === 'round') {
    switch (units) {
      case 'Metric':
        diameter = parseFloat(document.getElementById('ContactForm-diameter').value);
        break;
      case 'Imperial':
        if (document.getElementById('ContactForm-diameter-ft').value === '') {
          document.getElementById('ContactForm-diameter-ft').value = 0;
        }
        if (document.getElementById('ContactForm-diameter-in').value === '') {
          document.getElementById('ContactForm-diameter-in').value = 0;
        }
        const diameterFt = parseInt(document.getElementById('ContactForm-diameter-ft').value);
        const diameterIn = parseFloat(document.getElementById('ContactForm-diameter-in').value);
        if (diameterIn > 11) {
          return false;
        }
        // convert to cm
        diameter = ((diameterFt * 12) + diameterIn) * 2.54;
        break;
    }
  }
  if (document.getElementById('estimated-price-wrapper')) {
    let area = 0;
    if (rugType === 'rectangular') {
      if (!width || !length || !units || production === '') {
        return;
      }
      area = (width / 100 * length / 100);
    }
    if (rugType === 'round') {
      if (!diameter || !units || production === '') {
        return;
      }
      // area in m^2 - calculated as a square to account for manufacturing complexity
      area = Math.pow((diameter / 100), 2);
    }

    const pricePerMSq = getPrice(area);
    let price = area * pricePerMSq;

    const formattedPrice = price.toFixed(0);
    let currency, lang;
    switch (window.wmd?.market) {
      case 'gb':
      case 'international':
        currency = 'GBP';
        lang = 'en-GB';
        break;
      case 'eu':
      case 'european-union':
        currency = 'EUR';
        lang = 'en-GB';
        break;
      case 'us':
      case 'united-states':
      case 'middle-east':
        currency = 'USD';
        lang = 'en-US';
        break;
      default:
        currency = 'GBP';
        lang = 'en-GB';
    }
    const finalPrice = new Intl.NumberFormat(lang, { style: 'currency', currency: currency }).format(formattedPrice);
    document.getElementById('estimated-price').value = `${finalPrice}`;
  }
};

const changeUnits = (units) => {
  if (units === 'metric') {
    document.querySelectorAll('#wmdContactForm .metric').forEach(el => el.style.display = 'flex');
    document.querySelectorAll('#wmdContactForm .metric input').forEach(el => {
      el.disabled = false;
      el.required = true;
    });
    document.querySelectorAll('#wmdContactForm .imperial').forEach(el => el.style.display = 'none');
    document.querySelectorAll('#wmdContactForm .imperial input').forEach(el => {
      el.disabled = true;
      el.required = false;
      el.value = '0';
    });
  }
  else if (units === 'imperial') {
    document.querySelectorAll('#wmdContactForm .metric').forEach(el => el.style.display = 'none');
    document.querySelectorAll('#wmdContactForm .metric input').forEach(el => {
      el.disabled = true;
      el.required = false;
      el.value = '0';
    });
    document.querySelectorAll('#wmdContactForm .imperial').forEach(el => el.style.display = 'grid');
    document.querySelectorAll('#wmdContactForm .imperial input').forEach(el => {
      el.disabled = false;
      el.required = true;
    });
  }
  if (document.getElementById('estimated-price-wrapper')) {
    document.getElementById('estimated-price').value = '';
  }

};

const rearrangeCountries = () => {
  const selectElement = document.getElementById('AddressCountryNew');
  if (!!selectElement) {
    const topCountries = [
      'United Kingdom',
      'United States',
      'France',
      'Italy',
      'Australia',
      'Spain',
      'Ireland',
      'Netherlands',
      'Portugal',
      'Canada',
      'Germany'];
    const existingOptions = Array.from(
      new Set(Array.from(selectElement.querySelectorAll('option')).map(opt => opt.value))).
      map(value => Array.from(selectElement.querySelectorAll(`option[value="${value}"]`))[0]);

    const topOptions = [];
    let bottomOptions = [];
    existingOptions.forEach(option => {

      if (topCountries.includes(option.value) || option.value === '') {
        topOptions.push(option);
      }
      else {
        bottomOptions.push(option);
      }
      if (option.value === '---') {
        option.disabled = true;
      }
    });

    selectElement.textContent = '';

    topOptions.sort((a, b) => topCountries.indexOf(a.value) - topCountries.indexOf(b.value));

    bottomOptions.sort((a, b) => {
      if (a.value === '---') {
        return -1;
      }
      if (b.value === '---') {
        return 1;
      }
      return a.value.localeCompare(b.value);
    });

    topOptions.forEach(option => {
      selectElement.add(option);
    });

    bottomOptions.forEach(option => {
      selectElement.add(option);
    });

    selectElement.value = '';
  }
};

const validateEmailAddress = async (event) => {
  checkEnableSubmitButton();
  const postData = postConfig({
    email: event.target.value
  });
  const response = await fetch('/apps/wmd/api/validateEmail', postData);
  if (response.status === 200) {
    const data = await response.json();
    if (data.result.verdict !== 'Invalid') {
      isEmailValid = true;
      document.getElementById('emailValid').innerText = '';
      checkEnableSubmitButton();
    }
    else {
      isEmailValid = false;
      document.getElementById('emailValid').innerText = 'Email address not valid';
      checkEnableSubmitButton();
    }
  }
  else {
    isEmailValid = false;
    document.getElementById('emailValid').innerText = 'Error validating email address';
    checkEnableSubmitButton();
  }
};

document.addEventListener('DOMContentLoaded', () => {
  rearrangeCountries();
  document.getElementById('AddressCountryNew')?.addEventListener('change', manageState);
  document.getElementById('wmdSubmit').addEventListener('click', handleSubmit);

  if (document.getElementById('estimated-price-wrapper')) {
    const fields = [
      'ContactForm-width',
      'ContactForm-length',
      'ContactForm-diameter',
      'ContactForm-width-ft',
      'ContactForm-width-in',
      'ContactForm-length-ft',
      'ContactForm-length-in',
      'ContactForm-diameter-ft',
      'ContactForm-diameter-in'
    ];
    fields.forEach(fieldId => {
      const field = document.getElementById(fieldId);
      field?.addEventListener('focus', (event) => event.target.select());
      field?.addEventListener('input', () => {
        if (field.validity.rangeUnderflow || field.validity.rangeOverflow) {
          field.reportValidity();
        }
        else {
          calculatePrice();
        }
      });

    });

  }

  const metricRadio = document.getElementById('ContactForm-units-metric');
  const imperialRadio = document.getElementById('ContactForm-units-imperial');
  if (metricRadio) {
    metricRadio.addEventListener('click', () => changeUnits('metric'));
    imperialRadio.addEventListener('click', () => changeUnits('imperial'));

    switch (window.wmd?.market) {
      case 'gb':
      case 'eu':
      case 'middle-east':
      case 'international':
        metricRadio.click();
        break;
      case 'us':
      case 'united-states':
        imperialRadio.click();
        break;
      default:
        metricRadio.click();
    }
  }

  if (document.getElementById('ContactForm-appointment')) {
    window.flatpickr('#ContactForm-appointment', {
      enableTime: false,
      minDate: 'today',
      minTime: '10:00',
      maxTime: '17:00',
      disable: [
        function(date) {
          return (date.getDay() === 0 || date.getDay() === 6);
        }
      ]
    });
  }

  if (document.getElementById('ContactForm-phone')) {
    const phoneInputField = document.getElementById('ContactForm-phone');
    iti = window.intlTelInput(phoneInputField, {
      initialCountry: 'auto',
      geoIpLookup: (success, failure) => {
        fetch('https://ipapi.co/json').
          then((res) => res.json()).
          then((data) => success(data.country_code)).
          catch(() => failure());
      },
      countryOrder: ['gb', 'us', 'fr', 'it', 'de', 'es', 'au'],
      containerClass: 'field__input'
    });
    phoneInputField.addEventListener('change', formatNumber);
  }

  if (document.getElementById('ContactForm-email')) {
    const emailInputField = document.getElementById('ContactForm-email');
    emailInputField.addEventListener('change', validateEmailAddress);
  }
});

if (!customElements.get('rug-size-variables')) {
  customElements.define(
    'rug-size-variables',
    class RugSizeVariables extends HTMLElement {
      constructor() {
        super();
        document.addEventListener('wmd-variant-change', this.handleVariantChange);
      }

      handleVariantChange = (event) => {
        const variantId = event.detail.variant.id;
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        fetch(`${rootUrl}variants/${variantId}?section_id=rug-size-variables`).
          then(result => result.text()).
          then(html => {
            const response = new DOMParser().parseFromString(html, 'text/html').
              querySelector('.shopify-section').innerText;
            const json = JSON.parse(response);
            if (json.pricePerCmSq === 0) {
              document.getElementById('estimated-price-wrapper')?.classList.add('hidden');
              document.getElementById('estimated-price-disclaimer')?.classList.add('hidden');
            }
            else {
              document.getElementById('estimated-price-wrapper')?.classList.remove('hidden');
              document.getElementById('estimated-price-disclaimer')?.classList.remove('hidden');
            }
            window.wmd.pricePerCmSq = json.pricePerCmSq;
          });
      };

    });
}
